import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const ALLIANCE = [
  { name: 'Island Gold', url: 'https://eigoo-command.preview.emergentagent.com/?utm_source=fleet&utm_medium=alliance&utm_campaign=flagship', tag: 'Flagship' },
  { name: 'Siren Hub',   url: 'https://siren-storefront.preview.emergentagent.com/?utm_source=fleet&utm_medium=alliance&utm_campaign=siren',    tag: 'Storefront' },
  { name: 'Lead Sentry', url: 'https://lead-sentry-gold.preview.emergentagent.com/?utm_source=fleet&utm_medium=alliance&utm_campaign=leadsentry', tag: 'Intel' },
];

export const Footer = () => {
  return (
    <footer className="bg-[#050505] border-t border-[#D4AF37]/15 mt-32">
      <div className="px-6 md:px-12 lg:px-24 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-4">EIGOO</div>
            <h3 className="text-3xl md:text-4xl font-light tracking-tight mb-6 leading-tight">
              LIVE FREE
            </h3>
            <p className="text-sm text-[#A3A3A3] leading-relaxed max-w-md font-light">
              The Sovereign Relocation Hub. UK Relocation Bridge for Britons exiting the system.
              Nigeria Bridge for diaspora capital returning home. Identity-anchored, off-market,
              and held to lineage standards.
            </p>
            <div className="mt-8 text-[11px] tracking-[0.3em] uppercase text-[#A3A3A3]">
              livefree.eigooinc.net
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-5">Compass</div>
            <ul className="space-y-3">
              <li><Link to="/vault" className="text-sm text-[#A3A3A3] hover:text-[#D4AF37] transition-colors tracking-wide">The Vault</Link></li>
              <li><Link to="/valuation" className="text-sm text-[#A3A3A3] hover:text-[#D4AF37] transition-colors tracking-wide">Valuation Shield</Link></li>
              <li><Link to="/global-bridge" className="text-sm text-[#A3A3A3] hover:text-[#D4AF37] transition-colors tracking-wide">Global Bridge</Link></li>
              <li><Link to="/boarding" className="text-sm text-[#A3A3A3] hover:text-[#D4AF37] transition-colors tracking-wide">Boarding Application</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-5">Corridors</div>
            <ul className="space-y-3 text-sm text-[#A3A3A3] font-light">
              <li>Lagos · Ikoyi · Banana Island</li>
              <li>Abuja · Maitama</li>
              <li>Maui · Oahu · Big Island</li>
              <li>Concierge: by invitation</li>
            </ul>
          </div>
        </div>

        {/* Fleet Alliance — UTM-tracked signal links */}
        <div data-testid="fleet-alliance" className="mb-12 pt-12 border-t border-[#D4AF37]/15">
          <div className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-[#D4AF37]" />
            Fleet Alliance · Sovereign Nodes
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {ALLIANCE.map((node) => (
              <a
                key={node.name}
                href={node.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`alliance-${node.name.toLowerCase().replace(/\s/g, '-')}`}
                className="group border border-[#D4AF37]/20 hover:border-[#D4AF37] bg-[#0A0A0A] p-5 flex items-center justify-between transition-all hover:bg-[#D4AF37]/5"
              >
                <div>
                  <div className="text-[9px] tracking-[0.3em] uppercase text-[#A3A3A3] mb-1">{node.tag}</div>
                  <div className="font-display text-xl text-[#F5F5F5] group-hover:text-[#D4AF37] transition-colors">{node.name}</div>
                </div>
                <ArrowUpRight size={16} strokeWidth={1.5} className="text-[#D4AF37] group-hover:rotate-12 transition-transform" />
              </a>
            ))}
          </div>
        </div>

        <div className="gold-divider mb-8"></div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#A3A3A3]">
            © {new Date().getFullYear()} EIGOO INC · LIVE FREE · Sovereign Relocation Hub
          </div>
          <div data-testid="empowered-by-eigoo" className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] flex items-center gap-3">
            <span className="w-6 h-px bg-[#D4AF37]" />
            Empowered by EIGOO INC
            <span className="w-6 h-px bg-[#D4AF37]" />
          </div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#D4AF37]">
            75 / 25 · Admiral Split
          </div>
        </div>
      </div>
    </footer>
  );
};
